import React from 'react'
import Spinner from 'react-bootstrap/Spinner'

const Loading = () => {
    return (
        <>
            <Spinner animation="border" />
        </>
    )
}

export default Loading